// extracted by mini-css-extract-plugin
export var darkBlue = "#003e52";
export var darkGreen = "#3b693d";
export var green = "#3dae2b";
export var lightGreen = "#93d500";
export var newsGreen = "#ecf5d7";
export var orange = "#f90";
export var yellow = "#fbc900";
export var paleBlue = "#64a1bb";
export var blue = "#67b9e8";
export var blueishGrey = "#adc6d6";
export var coolGrey = "#e1e2e0";
export var white = "#fff";
export var almostWhite = "#f2eded";
export var lightGrey = "#d3d3d3";
export var lightishGrey = "#aba9a9";
export var grey = "#828382";
export var darkishGrey = "#666";
export var darkGrey = "#4b4d4b";
export var almostBlack = "#333";
export var error = "#ff3a3a";
export var warning = "#ffd162";
export var success = "#1ebc7b";
export var introSection = "rovensa-module--introSection--1lpxN";
export var introImage = "rovensa-module--introImage--3E0ga";
export var introSmallDescription = "rovensa-module--introSmallDescription--3FR7m";
export var smallDescription = "rovensa-module--smallDescription--1DthE";
export var logoContainer = "rovensa-module--logoContainer--1T2Gl";
export var introLogo = "rovensa-module--introLogo--1BA7N";
export var description = "rovensa-module--description--20144";
export var bodyImageContainer = "rovensa-module--bodyImageContainer--IymEZ";
export var bodyImage = "rovensa-module--bodyImage--qwJ4e";
export var video = "rovensa-module--video--2INZZ";
export var buttonWrapper = "rovensa-module--buttonWrapper--2fa8U";
export var button = "rovensa-module--button--3YhOd";
export var disabled = "rovensa-module--disabled--3Yskp";
export var organogramWrapper = "rovensa-module--organogramWrapper--1Htze";
export var orgranogramGroupContainer = "rovensa-module--orgranogramGroupContainer--1kkFM";
export var groupTitleContainer = "rovensa-module--groupTitleContainer--3Lo06";
export var groupTitle = "rovensa-module--groupTitle--3jwHr";
export var organogramLogoContainer = "rovensa-module--organogramLogoContainer--10mvf";
export var logoRowsContainer = "rovensa-module--logoRowsContainer--29DEj";
export var logoRow = "rovensa-module--logoRow--36-_m";
export var logo = "rovensa-module--logo--3a6Cy";
export var cropProtectionGroup = "rovensa-module--cropProtectionGroup--19j5g";
export var ascenzaLogo = "rovensa-module--ascenzaLogo--1-2x1";
export var selectisLogo = "rovensa-module--selectisLogo--3_MBx";
export var bioNutritionGroup = "rovensa-module--bioNutritionGroup--11g6W";
export var tradecorpLogo = "rovensa-module--tradecorpLogo--13TbR";
export var ogtLogo = "rovensa-module--ogtLogo--4ZZO5";
export var rodelLogo = "rovensa-module--rodelLogo--3rlM9";
export var microQuimicaLogo = "rovensa-module--microQuimicaLogo--2lzaX";
export var sdpLogo = "rovensa-module--sdpLogo--3zvJ8";
export var bioControlGroup = "rovensa-module--bioControlGroup--3BcnH";
export var idaiNatureLogo = "rovensa-module--idaiNatureLogo--3BMaD";
export var agrichemBioLogo = "rovensa-module--agrichemBioLogo--25vGq";
export var agroTecnologiaLogo = "rovensa-module--agroTecnologiaLogo--1cTXo";
export var oroagriLogo = "rovensa-module--oroagriLogo--IJqMb";